@if(textLabel()) {
<app-label-input [hasTooltip]="hasTooltip()" [required]="required()" [textTooltip]="textTooltip()!"
   [textLabel]="textLabel()!" />
}
@if(disabled() && !required()) {
<mat-form-field class="w-100 text-area" appearance="outline">
   <textarea matInput [type]="type()" [value]="value()" disabled [rows]="rows()"></textarea>
</mat-form-field>
}@else {
<mat-form-field class="w-100 text-area pos-relative" appearance="outline">
   <textarea matInput [placeholder]="placeholder()" [rows]="rows()" [formControlName]="nameControl()!"
      (blur)="onChangeBlur()"></textarea>
</mat-form-field>
}